import type { RoleplayCard } from '@wundo/shared/roleplay.ts';

/**
 * The library with this week's practice conversation at the top.
 *
 * A pilot member is mailed one conversation a week, and the mail's whole
 * promise is that it is waiting for them — so it is the first card, whatever
 * the order somebody arranged the library in. Everything else keeps that order.
 */
export function thisWeekFirst(
  library: readonly RoleplayCard[],
  thisWeekId: string | null,
): RoleplayCard[] {
  const pinned = library.find((card) => card.id === thisWeekId);
  if (pinned === undefined) return [...library];

  return [pinned, ...library.filter((card) => card !== pinned)];
}
